<a class="skip-link" [href]="skipHref" (click)="skipToMain($event)">Skip to main content</a>

<router-outlet></router-outlet>

<!-- After the routed layout so keyboard focus reaches the header before this floating widget. -->
<app-chatllm />
